// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  if (role === "admin") {
    return true;
  }

  if (params.resource === "pipeline_queue") {
    return false;
  }

  // Echo Studio replays pipeline evidence: administrators only. The server
  // proxy and the dashboard API enforce this independently.
  if (params.resource === "echo_studio") {
    return false;
  }

  // Stuck-Echo incidents list customers, their Echoes and chat links:
  // administrators only, enforced again by the proxy (`/monitoring/*`) and the
  // dashboard API.
  if (params.resource === "echo_incidents") {
    return false;
  }

  // Non admins can't access the sales resource
  if (params.resource === "sales") {
    return false;
  }

  // Non admins can't access the configuration resource
  if (params.resource === "configuration") {
    return false;
  }

  // Non admins can't manage feature cohorts (phone-number roles/flags for
  // the WhatsApp bot — membership grants bot capabilities, so admin-only)
  if (
    params.resource === "feature_cohorts" ||
    params.resource === "feature_cohort_members" ||
    params.resource === "feature_cohort_implications"
  ) {
    return false;
  }

  // Non admins can't manage agency tenants (membership grants bot
  // capabilities + branding; portal users are external logins — admin-only).
  // `agency_billing` is the Studio wallet panel and its film grants; the
  // /api/studio-billing proxy enforces the administrator again.
  if (
    params.resource === "agencies" ||
    params.resource === "agency_billing" ||
    params.resource === "agency_members" ||
    params.resource === "agency_portal_users" ||
    params.resource === "agency_brand_profiles" ||
    params.resource === "brand_extractions"
  ) {
    return false;
  }

  // Outreach (first films, templated email and its tracking) lists agents by
  // name and e-mail and sends as the operator: administrators only, enforced
  // again by the `outreach` edge function and its RPCs.
  if (params.resource === "outreach") {
    return false;
  }

  // Non admins can't see global marketing / acquisition analytics
  // (campaign spend + the funnel across all contacts) — admin-only.
  if (params.resource === "marketing_metrics") {
    return false;
  }

  // Frame-level QC evidence includes private user media and reviewer identity.
  // It is restricted to the same administrator boundary enforced by the API.
  if (params.resource === "echo_feedback") {
    return false;
  }

  // Raw captured email addresses (HD-poster-by-email) are PII — admin-only.
  if (params.resource === "echoflicks_poster_emails") {
    return false;
  }

  return true;
};
